import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './styles/index.css'
import { registerServiceWorker } from './registerServiceWorker'
import { applyTheme, getStoredTheme } from './utils/theme'
import './i18n'

// Vor dem ersten Render anwenden, damit beim Laden nicht kurz das Standard-Design aufblitzt.
applyTheme(getStoredTheme())

// Nach einem Deploy verweisen bereits offene Tabs noch auf die alten Chunk-Hashes eines
// lazy-geladenen Routen-Bundles. Vite meldet das ueber dieses Event statt eines rohen
// Promise-Rejections - ein Reload holt die aktuelle index.html mit den neuen Hashes.
window.addEventListener('vite:preloadError', () => {
  window.location.reload()
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)

registerServiceWorker()
